import React, { Component } from "react";
import axios from "axios";
import Helping from "../../helpers/Helping";
import { Link } from "react-router-dom";
import { addCurrentRoute } from "../../actions/profile_action";
import Notification from "../layout/Notification";
import { connect } from 'react-redux';
import { trackPromise } from "react-promise-tracker";
import LoadingButton from "../fields/LoadingButton";
import {
    MESSAGE
} from '../../config/index';
import {
    API_URL,
    META_MASK,
    MATIC_META_MASK,
    TEZOS_META_MASK,
    STORE_WEBSITE,
    ETH_TRANSACTION_HASH_LINK,
    MATIC_TRANSACTION_HASH_LINK,
    TEZOS_TRANSACTION_HASH_LINK
} from '../../config/urls';

const { NOT_FOUND } = MESSAGE;
class Detail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: '',
            transaction: {},
            pageTitle: 'Transaction Detail',
            routeName: '/transactions',
            error_message: '',
            error_type: '',
            isLoading: true,
            btnIsEnable: false,
            totalAmount: 0,
            re_call: {
                is_loading: false,
            }
        };

        this.transferRecall = this.transferRecall.bind(this)
    }

    componentDidMount() {
        var self = this;

        if (this.props.match.params.id) {
            let id = this.props.match.params.id;
            this.props.addCurrentRoute(this.props.profile, this.props.location.pathname);

            self.setState({
                url: API_URL.ADMIN_TRADING_API + "transactions/" + id
            }, function () {
                self.getById();

            });
        }
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    getById() {
        let self = this;

        trackPromise(
            axios.get(this.state.url, Helping.getConfig()).then(response => {
                var transaction = response.data.payload.transactions;
                self.getTotalAmount(transaction);

                self.setState({
                    transaction: transaction,
                    isLoading: false
                });
            }).catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    return self.setState({
                        error_message: error.response.data.message,
                        error_type: 'danger',
                        isLoading: false
                    });
                }
                return this.setState({
                    isLoading: false,
                    ...Helping.setNetworkRequestError(error, "fetching transaction")
                })
            })
        )
    }

    getTotalAmount(transaction) {
        if (transaction.details.length < 1) {
            return false;
        }
        let currentValue = [];
        const reducer = (accumulator = 0, currentValue) => Number(accumulator) + Number(currentValue);
        transaction.details.map(detail => currentValue.push(detail.amount));
        let totalAmount = currentValue.reduce(reducer);
        this.setState({ totalAmount: totalAmount });
    }

    getMetaMaskLink = (transaction, copy) => {
        if (transaction.which_bc === "MATIC")
            return MATIC_META_MASK.LINK + copy.id;

        else if (transaction.which_bc === "ETH")
            return META_MASK.LINK + copy.id;

        else if (transaction.which_bc === "TEZOS")
            return TEZOS_META_MASK.LINK + copy.id;
    }

    getTransactionHashLink = (item) => {
        if (item.which_bc === "MATIC")
            return MATIC_TRANSACTION_HASH_LINK + item.transactionHash;

        else if (item.which_bc === "ETH")
            return ETH_TRANSACTION_HASH_LINK + item.transactionHash;

        else if (item.which_bc === "TEZOS")
            return TEZOS_TRANSACTION_HASH_LINK + item.transactionHash;
    }

    transferRecall() {
        let { re_call, transaction } = this.state
        re_call.is_loading = true;
        let self = this

        this.setState({
            re_call: re_call
        })

        axios.post(API_URL.ADMIN_TRADING_API + 'settings', {
            action: "transaction-transfer-call",
            id: transaction.id
        }, Helping.getConfig()).then(response => {

            re_call.is_loading = false
            self.setState({
                re_call: re_call,
                error_message: response.data.message,
                error_type: 'success'
            },
               () => window.$('#confirmTransferRecall').modal('hide'))
            self.getById()
        })
            .catch(error => {
                re_call.is_loading = false

                if (error.response) {
                    self.setState({
                        re_call: re_call,
                        error_message: error.response.data.message,
                        error_type: 'success'
                    })
                }
            });
    }

    getSeller(seller) {
        if (seller.username.includes('terra.admin'))
            return 'Terra Virtua';
        else
            return seller.username;
    }

    render() {
        let { transaction, re_call } = this.state;

        return (
            <>
                <div class="content user-view">
                    {transaction.status && (
                        <>
                            <div class="top-header">
                                <div class="header-title">
                                    <h2 class="title">{transaction.buyer.username}</h2>
                                    <span class="title-caption">Buyer</span>
                                </div>
                                <div class="header-btn">
                                    <button class="custom-btn dark-btn icon-btn sm-btn" onClick={() => this.props.history.goBack()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
                                        <span class="txt-btn">Back</span>
                                    </button>

                                    {transaction.status === 'processing' &&
                                        <button class="custom-btn gradiant-btn sm-btn" data-toggle="modal" data-target="#confirmTransferRecall">Transfer Re-Call</button>
                                    }
                                </div>
                            </div>

                            {this.state.error_message && (
                                <Notification
                                    type={this.state.error_type}
                                    message={this.state.error_message}
                                    callback={this.removeNetworkError}
                                />
                            )}

                            <div class="main-content  view-page-content">
                                <div class="view-tabs double-tabs">
                                    <ul class="nav nav-tabs" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link active" data-toggle="tab" href="#transactionDetail" role="tab">
                                                <svg id="info" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path id="Path_394" data-name="Path 394" d="M11,2a9,9,0,1,0,9,9A9,9,0,0,0,11,2Zm0,1.8A7.2,7.2,0,1,1,3.8,11,7.2,7.2,0,0,1,11,3.8Z" transform="translate(-2 -2)"></path><g id="info-2" data-name="info" transform="translate(-444 -18)"><rect id="Rectangle_277" data-name="Rectangle 277" width="1.5" height="6" rx="0.75" transform="translate(452.5 25)"></rect><rect id="Rectangle_278" data-name="Rectangle 278" width="1.5" height="1.5" rx="0.75" transform="translate(452.5 22.5)"></rect></g></svg>
                                                <span class="tab-text">Details</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" data-toggle="tab" href="#productInfo" role="tab">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                    <path id="Star" d="M12.136,2.531a1.71,1.71,0,0,0-1.489,1.122L8.523,8.207l-4.847.726A1.664,1.664,0,0,0,2.757,11.9l3.485,3.53-.823,4.984c-.27,1.625,1.039,2.618,2.439,1.848.536-.295,3.258-1.816,4.277-2.376l4.309,2.376c1.4.77,2.683-.223,2.408-1.848l-.824-4.984,3.486-3.53A1.664,1.664,0,0,0,20.6,8.933l-4.848-.726L13.625,3.653A1.708,1.708,0,0,0,12.136,2.531Zm0,2.738,2.059,4.39a.981.981,0,0,0,.76.561l4.658.693-3.39,3.4a1.109,1.109,0,0,0-.285.957l.792,4.785-4.118-2.277a.988.988,0,0,0-.951,0c-.517.284-3.01,1.668-4.118,2.277l.792-4.785a1.126,1.126,0,0,0-.285-.957l-3.39-3.4,4.658-.66a1.017,1.017,0,0,0,.76-.594Z" transform="translate(-2.136 -2.531)" />
                                                </svg>
                                                <span class="tab-text">Product Info</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="tab-content">
                                    <div class="tab-pane active" id="transactionDetail" role="tabpanel">
                                        <div class="row">
                                            <div class="col-sm-6 col-md-6 col-lg-4">
                                                <ul class="list-view">
                                                    <li>
                                                        <label for="">Transactions ID</label>
                                                        <span>{transaction.id}</span>
                                                    </li>
                                                    <li>
                                                        <label for="">Buyer</label>
                                                        <span>{transaction.buyer.username}</span>
                                                    </li>
                                                    <li>
                                                        <label for="">Seller</label>
                                                        <span>{transaction.details ? this.getSeller(transaction.details[0].seller) : 'Nil'}</span>
                                                    </li>
                                                    <li>
                                                        <label for="">Status</label>
                                                        <span>{Helping.getTitleCase(transaction.status)}</span>
                                                    </li>
                                                    <li>
                                                        <label for="">Type</label>
                                                        <span>{Helping.getTitleCase(transaction.type)}</span>
                                                    </li>
                                                    <li>
                                                        <label for="">Payment Type</label>
                                                        <span>{Helping.removeSpacialCharactersFromString(transaction.payment_type)}</span>
                                                    </li>
                                                    <li>
                                                        <label for="">Campaign Type</label>
                                                        <span>{Helping.removeSpacialCharactersFromString(transaction.campaign_type)}</span>
                                                    </li>
                                                    <li>
                                                        <label for="">Amount</label>
                                                        <span>${parseFloat(transaction.totalAmount).toFixed(2)}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-sm-6 col-md-6 col-lg-5">
                                                <ul class="list-view">
                                                    <li>
                                                        <label for="">Eth Amount</label>
                                                        <span>{transaction.eth_amount + " ETH"}</span>
                                                    </li>
                                                    {transaction.coupon && (
                                                        <li>
                                                            <label for="">Coupon</label>
                                                            <span>{transaction.coupon.code}</span>
                                                        </li>
                                                    )}
                                                    {transaction.couponValue && (
                                                        <li>
                                                            <label for="">Coupon Value</label>
                                                            <span>{transaction.couponValue}</span>
                                                        </li>
                                                    )}
                                                    {transaction.which_bc && (
                                                        <li>
                                                            <label for="">Blockchain</label>
                                                            <span>{transaction.which_bc}</span>
                                                        </li>
                                                    )}
                                                    {transaction.checkoutId && (
                                                        <li>
                                                            <label for="">Checkout ID</label>
                                                            <span>{transaction.checkoutId}</span>
                                                        </li>
                                                    )}
                                                    {transaction.discount_value && (
                                                        <li>
                                                            <label for="">Discount Value</label>
                                                            <span>{transaction.discount_value}</span>
                                                        </li>
                                                    )}
                                                    <li>
                                                        <label for="">Reference Number</label>
                                                        <span>{transaction.referenceNumber}</span>
                                                    </li>
                                                    <li>
                                                        <label for="">Created at</label>
                                                        <span>{Helping.convertTimeToHumanReadableFormat(transaction.created_at)}</span>
                                                    </li>
                                                    {transaction.buyer.pub_key && (
                                                        <li>
                                                            <label for="">Public Key</label>
                                                            <span class="d-link">{transaction.buyer.pub_key}</span>
                                                        </li>
                                                    )}
                                                    {transaction.eth_transaction_hash && (
                                                        <li>
                                                            <label for="">Payment Hash</label>
                                                            <span class="link">
                                                                <a class="link" href={ETH_TRANSACTION_HASH_LINK + transaction.eth_transaction_hash}
                                                                    target="_blank">
                                                                    {transaction.eth_transaction_hash}
                                                                </a>
                                                            </span>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                            <div class="col-12">
                                                <ul class="list-view">
                                                    {transaction.transactionHash && (
                                                        <li>
                                                            <label for="">Transaction Hash</label>
                                                            <span class="link d-link">
                                                                <a class="link" href={this.getTransactionHashLink(transaction)}
                                                                    target="_blank">
                                                                    {transaction.transactionHash}
                                                                </a>
                                                            </span>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    {transaction.details && (
                                        <div class="tab-pane" id="productInfo" role="tabpanel">
                                            <div class="listing-tbl table-responsive">
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">ID</th>
                                                            <th scope="col">Product Name</th>
                                                            <th class="text-center" scope="col">Image</th>
                                                            <th scope="col">Code</th>
                                                            <th scope="col">Amount</th>
                                                            <th scope="col">Seller</th>
                                                            <th scope="col">Blockchain</th>
                                                            <th scope="col">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {transaction.details.map((detail, i) => (
                                                            <tr key={i}>
                                                                <td scope="row">{detail.item_detail.id}</td>
                                                                <td>{detail.item_detail.item.name}</td>
                                                                <td>
                                                                    <div class="newsCoverImg">
                                                                        <img src={detail.item_detail.item.thumbnail_url} alt="" class="img-fluid" />
                                                                    </div>
                                                                </td>
                                                                <td>{detail.item_detail.code}</td>
                                                                <td>${Helping.parseAmount(detail.amount)}</td>
                                                                <td>
                                                                    {detail.seller.role === "admin" ? (
                                                                        detail.seller.firstName +
                                                                        " " +
                                                                        detail.seller.lastName
                                                                    ) : (
                                                                        detail.seller.username + "(" + detail.seller.pub_key + ")"
                                                                    )}
                                                                </td>
                                                                <td>{transaction.which_bc}</td>
                                                                <td>
                                                                    <div class="action-links">
                                                                        <a class="icon location" title='Blockchain Info' target="_blank"
                                                                            href={this.getMetaMaskLink(transaction, detail.item_detail)}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-globe"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
                                                                        </a>
                                                                        <a href={STORE_WEBSITE + 'item/' + detail.item_detail.code} class="icon view" title="View Item Detail" target="_blank">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                                                        </a>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                    {(!transaction.status && !this.state.isLoading) && (
                        <div className="table-responsive">
                            <Notification type="danger"
                                message={Helping.getMessageString(NOT_FOUND, "Transaction")}
                                callback={this.removeNetworkError} />
                        </div>
                    )}
                </div>

                {/* Confirmation Transfer Re-call */}
                <div class="actionModal modal fade" id="confirmTransferRecall" tabindex="-1" role="dialog" aria-labelledby="confirmTransferRecall" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLongTitle">Confirm Transfer Re-call </h5>
                            </div>

                            <div class="modal-body">
                                <p class="modal-msg">You are about to confirm the transfer re-call.</p>
                                <p><strong>Do you want to proceed?</strong></p>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal">Close</button>
                                {re_call.is_loading ?
                                    <LoadingButton class_name={"sm-btn"} />
                                    :
                                    <button type="button" class="custom-btn sm-btn gradiant-btn" onClick={this.transferRecall}>{re_call.is_loading ? "Loading..." : "Confirm"}</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = state => ({
    profile: state.profile
});

const mapDispatchToProps = {
    addCurrentRoute
}

export default connect(mapStateToProps, mapDispatchToProps)(Detail);
